import React from 'react';
import { Link } from 'react-router-dom'
import IconosServicios from '../../../Global/IconosServicios.js'
//import cintaVerde from '../../../../imagenes/paquetes/ribbon/ribbon-green.png'
//import cintaVerde2x from '../../../../imagenes/paquetes/ribbon/ribbon-green@2x.png'
//import cintaVerde3x from '../../../../imagenes/paquetes/ribbon/ribbon-green@3x.png'
import allInclusive from '../../../../imagenes/paquetes/ribbon/allInclusiveNuevo.png'
import {mostrarMes, formatearFecha, transformText} from '../../../../utils/Tools'
import {FacebookShareButton, FacebookIcon, TwitterShareButton, TwitterIcon, WhatsappShareButton, WhatsappIcon} from 'react-share';
// import cintaRoja from '../../../../imagenes/paquetes/ribbon/ribbon-red.png'
// import cintaRoja2x from '../../../../imagenes/paquetes/ribbon/ribbon-red@2x.png'
// import cintaRoja3x from '../../../../imagenes/paquetes/ribbon/ribbon-red@3x.png'
import paquete from '../../../../imagenes/logo/cinta-valija.png'


class DestinoCuadro extends React.Component {

    mostrarCintaDescuento(producto) {
      if (producto.charters.length > 0 && (producto.charters[0].tarifaAlterada > 0 || producto.charters[0].promoValijaYa > 0)) {
        return <div className="ribbon-container">
                  {/* <img src={cintaRoja} alt="Etiqueta que dice % Off" srcSet={cintaRoja + ' 1x, ' + cintaRoja2x + ' 2x, ' + cintaRoja3x + ' 3x'}  className="ribbon" /> */}
                    <h6>{producto.charters[0].promoValijaYa.split(".",1)} % <br />Off</h6>
                    {/*<h6>{producto.charters[0].totalDescuento} % Off</h6>*/}
                </div>
        } else if (producto.regimen.codigo === 'PCF') {
          return <div className="ribbon-container all-inclusive">
                    <img src={allInclusive} alt="Etiqueta All Inclusive" className="ribbon"  style={{top: '8px', right: '9px'}}/>
                  </div>
        }

      return null
    }

    shareClick(e) {
      e.preventDefault();
      return;
    }


    render() {
      const { producto, origen } = this.props;

      const imagen = {
        backgroundImage: 'url(assets/img/destinos/bg/' + producto.destino.imagenes[0] + ')',
        backgroundPosition: 'center center',
        backgroundRepeat: 'no-repeat',
        borderRadius: '16px 16px 0 0'
      };
      
      //FC: antes del refactor de la tabla nueva
      //const precioPaquete = Math.round(((this.props.producto.tarifas[0].tarifaNeta - (this.props.producto.charters[0].tarifa.tarifaNeta * (this.props.producto.charters[0].promoValijaYa / 100))) * this.props.producto.moneda.cotizacion)).toLocaleString();
      //FC: despues del refactor
      const precioPaquete = Math.round(producto.tarifas[0].tarifaNeta);

        return (
                <div className="destino">
                  <Link to={`/paquetes-turisticos/${origen}/${producto.destino.idDestino}/${formatearFecha(producto.charters[0].fechaSalida)}/${producto.idProducto}/${producto.charters[0].idCharter}`}>
                    {/*--INFO SOBRE FOTO--*/}
                    <div className="bg" style={imagen}>
                      {/*--ESTADIA--*/}
                      <div className="estadia">
                        <div className="icon-container-nuevo">
                          <img alt="Paquetes" title="Paquetes" src={paquete} height="32"  />
                          <span className='sp-label'>{producto.dias} d&iacute;as - {producto.noches} noches</span>
                         {/*  <i className="material-icons">card_travel</i> */}
                        </div>
                       
                      </div>
                      {/*--RIBBON--*/}
                      {this.mostrarCintaDescuento(producto)}

                      {/*--FEATURES--*/}
                      <IconosServicios producto={producto} />
                    </div>
                    {/*--INFO DEBAJO DE FOTO--*/}
                    <div className="info">
                      <h3>{transformText(producto.destino.descripcion)}</h3>
                      <h5>{mostrarMes(producto.charters[0].fechaSalida)} {producto.charters[0].fechaSalida.split('-')[0]}</h5>
                      <h2>{producto.moneda.simbolo} {precioPaquete.toLocaleString()}</h2>
                      {producto.tarifaPorHabitacion === 1 && <p>Tarifa por Persona <br /> en Base Triple/Cuadruple</p> }
                      <p>+ tasas e impuestos</p>
                      <div onClick={(e) => e.preventDefault()} className="redesSociales btn-group dropup">
                        <button className="btn btn-default btn-xs "
                                type="button" data-toggle="dropdown">
                                <i className="material-icons">share</i>
                        </button>
                        <ul className="dropdown-menu">
                          <li>
                            <FacebookShareButton
                              hashtag='#PedrazaViajes' quote={producto.detalleWeb}
                              url={`https://pedraza.com.ar/paquetes-turisticos/${origen}/${producto.destino.idDestino}/${formatearFecha(producto.charters[0].fechaSalida)}/${producto.idProducto}`}
                              className="">
                              <FacebookIcon
                                size={32}
                                bgStyle={{fill: "#181e35"}}
                                iconFillColor="#fff"
                                round />
                            </FacebookShareButton>
                          </li>
                          <li>
                            <TwitterShareButton
                              hashtag='#PedrazaViajes'
                              url={`https://pedraza.com.ar/paquetes-turisticos/${origen}/${producto.destino.idDestino}/${formatearFecha(producto.charters[0].fechaSalida)}/${producto.idProducto}`}
                              title={`Pedraza Viajes y Turismo ${producto.detalleWeb}`}
                              className="">
                              <TwitterIcon
                                size={32}
                                bgStyle={{fill: "#181e35"}}
                                iconFillColor="#fff"
                                round />
                            </TwitterShareButton>
                          </li>
                          <li>
                            <WhatsappShareButton
                              url={`https://pedraza.com.ar/paquetes-turisticos/${origen}/${producto.destino.idDestino}/${formatearFecha(producto.charters[0].fechaSalida)}/${producto.idProducto}`}
                              title='Paquete De Pedraza Viajes y Turismo'
                              separator=" "
                              className="">
                              <WhatsappIcon 
                                size={32} 
                                bgStyle={{fill: "#181e35"}}
                                iconFillColor="#fff" 
                                round />
                            </WhatsappShareButton>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </Link>
                </div>
          );
    }
}

export default DestinoCuadro

//paquetes-turisticos/Chile-Semana-Santa-Unico/17425/GUL/ARS/2/2018-03-29
//paquetes-turisticos/listado-de-paquetes?origen=BUE&destino=PCM&periodo=2018-3&pasajeros=2-10-5



// WEBPACK FOOTER //
// ./src/components/Home/DestinoFila/DestinoCuadro/index.js